import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField } from '@mui/material'

import { usePolicyEditContext } from '../../policyEditController'

/**
 * The policy name when the user edits, creates or duplicates a policy. It is where the details
 * page shows the name as a heading. Like the old `PolicyName` input, leaving it checks the form.
 */
export const ThemedPolicyNameField: FC = () => {
  const { t } = useTranslation()
  const { policy, editPolicy, validatePolicy, formErrors } = usePolicyEditContext()

  if (!policy) return null

  return (
    <TextField
      required
      size="small"
      label={t('policiesLibrary.policyName', 'Policy Name')}
      value={policy.policyName ?? ''}
      onChange={event => editPolicy(p => p.setPolicyName(event.target.value))}
      onBlur={validatePolicy}
      error={!!formErrors.policyName}
      helperText={formErrors.policyName}
      sx={{ flex: 1, maxWidth: 480 }}
    />
  )
}
